// src/utils/ScrollHandler.js (Create this new file)





import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollHandler() {
  const { pathname, state } = useLocation(); // Get current path and any navigation state

  useEffect(() => {
    // Check if state was passed and if preventScrollReset is true
    const shouldPreventScroll = state?.preventScrollReset === true;

    // If the flag is NOT set or is false, perform the default scroll to top
    if (!shouldPreventScroll) {
      try {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'instant', // Use 'instant' to avoid smooth scroll animation interference
        });
      } catch (error) {
        // Fallback for older browsers
        window.scrollTo(0, 0);
      }
    }
    // If shouldPreventScroll is true, do nothing - leave scroll position as is.

    // We only want this effect to run when the pathname changes,
    // *or* when the specific state we care about changes.
  }, [pathname, state?.preventScrollReset]); // Dependency array

  return null; // This component doesn't render anything visible
}

export default ScrollHandler;